import { API } from 'config/axios'

const requests = {
  auth: {
    login: (body) => API.post('/auth/login', body),
    register: (body) => API.post('/auth/register', body),
    updateUser: (body) => API.post('/auth/updateUser', body),
    getUsers: (id,search) => API.get('/auth/getUsers', { params: { id,search } }),
    deleteUser: (id) => API.delete(`/auth/deleteUser/${id}`), // Kullanıcı silme için DELETE isteği


  },
  dashboard: {
    getTotalCount: () => API.get('/list/getTotalCount')
  },

  company: {
    list: () => API.get('/list/company'),
    create: (body) => API.post('/company/create', body)
  },
  brand: {
    list: () => API.get('/list/brand'),
    listDepartment: (id) => API.get('/list/department/' + id),
    listSubDepartment: (id) => API.get('/list/subDepartment/' + id)
  },
  country: {
    list: () => API.get('/list/country'),
    listHome: () => API.get('/list/countryHome')
  },
  homeproducts:{
    list:()=>API.get('/list/zaraHomeProducts')
  },
  size: {
    listGroup: (department) => API.get('/list/sizeGroup', { params: { department } }),
    listGroupHome: (department) => API.get('/list/sizeGroupHome', { params: { department } })
  },
  referance: {
    list: (subDepartment) => API.get('/list/referance', { params: { subDepartment } })
  },
  symbol: {
    list: (washType) => API.get(`/list/symbol/${washType}`),
    listHome: (washType) => API.get(`/list/symbolHome/${washType}`)
  },
  additionalPhrases: {
    list: () => API.get('/list/additionalPhrases'),
    washList: () => API.get('/list/washingAdditionalPhrases'),
    washListHome: () => API.get('/list/washingAdditionalPhrasesHome')
  },
  fabric: {
    list: () => API.get('/list/fabric'),
    typeList: () => API.get('/list/fabrictype'),
    listHome: () => API.get('/list/fabricHome'),
    typeListHome: () => API.get('/list/fabrictypeHome'),
    lang: (name) => API.get('/list/fabricTranslate/' + name),
    langHome: (name) => API.get('/list/fabricTranslateHome/' + name)
  },
  order: {
    create: (body) => API.post('/order/create', body),
    createwarning: (body) => API.post('/order/createwarning', body),
    createprice: (body) => API.post('/order/createprice', body),
    createbelt: (body) => API.post('/order/createbelt', body),
    createbrand: (body) => API.post('/order/createbrand', body),
    addZaraHomeProduct: (body) => API.post('/order/addZaraHomeProduct', body),
    updateZaraHomeProduct: (body) => API.post('/order/updateZaraHomeProduct', body),
    createaddional: (body) => API.post('/order/createaddional', body),
    createcord: (body) => API.post('/order/createcord', body),    
    createempty: (body) => API.post('/order/createempty', body),
    getBrandSvg: (code, params) => API.get(`/order/getBrandSvg/${code}`, { params: params }) ,
    getBrandSvgHome: (code, params) => API.get(`/order/getBrandSvgHome/${code}`, { params: params }) ,
     convertPdfToSvg: (formData) => API.post('/order/convertPdfToSvg', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }),

    updateprice: (id, body) => API.post('/order/updateprice/' + id, body),
    updatewarning: (id, body) => API.post('/order/updatewarning/' + id, body),
    updatebelt: (id, body) => API.post('/order/updatebelt/' + id, body),
    updatebrand: (id, body) => API.post('/order/updatebrand/' + id, body),
    updateaddional: (id, body) => API.post('/order/updateaddional/' + id, body),
    updatecord: (id, body) => API.post('/order/updatecord/' + id, body),
    updateempty: (id, body) => API.post('/order/updateempty/' + id, body),


    update: (id, body) => API.post('/order/update/' + id, body),
    updateStatus: (id, body) => API.post('/order/updateStatus/' + id, body),
    list: (status,page, search) => API.get('/order/list?status=' + status, { params: { page,search } }),
    get: (id) => API.get('/order/' + id),
    getArtworkOrder: (id, tab) => API.get('/list/artwork/' + id, { params: { tab } }),
    getArtworkOrderHome: (id, tab) => API.get('/list/artworkHome/' + id, { params: { tab } }),
    copyOrder: (id) => API.get('/order/copyOrder', { params: { id } }),
    addSymbolTranslate: (body) => API.post('/order/symbolTranslate', body),
    addReferenceCode: (body) => API.post('/order/addReferenceCode', body),
    deleteReferenceCode: (body) => API.post('/order/deleteReferenceCode', body),
    updateReferenceCode: (body) => API.post('/order/updateReferenceCode', body),
    uploadSizeGroupExcel: (formData, params) => API.post('/order/uploadSizeGroupExcel', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      },
      params: params
    })

    
  },
  report: {
    create: (params) => API.get('/report/create', { params }),
    createOrder: (params) => API.get('/report/createOrder', { params })
  },
  pdf: {
    createPDF: (body) => API.post('/pdf/create-pdf', body, { responseType: 'blob' }),
  },
  sizeGroup: {
    list: (brand) => API.get('/sizeGroups/sizeGroups', { params: { brand } }),
    get: (id, brand) => API.get(`/sizeGroups/sizeGroup/${id}`, { params: { brand } }),
    create: (body) => API.post('/sizeGroups/sizeGroup', body),
    update: (id, body) => API.put(`/sizeGroups/sizeGroup/${id}`, body),
    delete: (id, brand) => API.delete(`/sizeGroups/sizeGroup/${id}`, { params: { brand } }),
    addSize: (id, body) => API.post(`/sizeGroups/sizeGroup/${id}/size`, body),
    updateSize: (id, sizeIndex, body) => API.put(`/sizeGroups/sizeGroup/${id}/size/${sizeIndex}`, body),
    deleteSize: (id, sizeIndex, brand) => API.delete(`/sizeGroups/sizeGroup/${id}/size/${sizeIndex}`, { params: { brand } })
  },
}

export default requests
